import { render, staticRenderFns } from "./FormWizard.vue?vue&type=template&id=4967d678&scoped=true"
import script from "./FormWizard.vue?vue&type=script&lang=js"
export * from "./FormWizard.vue?vue&type=script&lang=js"
import style0 from "./FormWizard.vue?vue&type=style&index=0&id=4967d678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967d678",
  null
  
)

export default component.exports